import VuMeter from './VuMeter.vue'
export default VuMeter

export interface VuMeterStreamInfo {
  streamId: string,
  channel: number,
  volume: number
}
